import { z } from "zod";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const BookingReservationStatus = z.enum([
    "unselected",
    "prebooked",
    "confirmed",
    "cancelled",
]);

export type BookingReservationStatus = z.infer<typeof BookingReservationStatus>;
